module.exports = __webpack_public_path__ + "img/cardImg2.565257f0.png";